var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card bg-gradient-danger"},[_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"card-title text-white"},[_vm._v(_vm._s(_vm.$t('auth.change-your-password')))]),_vm._v(" "),_c('blockquote',{staticClass:"blockquote text-white mb-0"},[_c('p',[_vm._v(_vm._s(_vm.$t('auth.change-your-password-description')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }